import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupPackagingList } from '@shared/api/lib/group/group';
import {
  GroupPackagingListParams,
  PaginatedGroupPackagingList,
} from '@shared/api/types';

/**
 * Cross-org Packaging aggregation grouped by
 * `(item_type, name, external_id)`. Filters by `organizations` and an end-date
 * window via `dateStart`/`dateEnd`.
 *
 * The `enabled` option lets callers gate the query when sharing a single
 * component between this and the food-and-drink endpoint.
 */
export const useGetGroupPackaging = (
  params?: GroupPackagingListParams,
  options?: { enabled?: boolean }
) =>
  useGroupPackagingList<PaginatedGroupPackagingList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
      enabled: options?.enabled ?? true,
    },
  });
